<template>
    <img
        height="100"
        width="220"
        class="cover rounded shadow"
        :src="'/storage/' + item.image"
        :alt="item.name_ka"
        v-if="item.image"
    />
    <img
        height="100"
        width="220"
        class="cover rounded shadow"
        :src="
            'https://ui-avatars.com/api/?uppercase=true&bold=true&background=random&size=256&name=' +
            item.name_ka
        "
        :alt="item.name_ka"
        v-else
    />
    <div></div>
    <span class="mt-2 badge bg-primary shadow" v-show="item.fixed_price">{{
        item.fixed_price + "₾"
    }}</span>
    <h6 class="mt-2 mb-0">
        <small>{{ item.name_ka }}</small>
    </h6>
    <p class="mb-0">
        <small v-if="category === 'agencies'">
            {{ item.municipality.name_ka }} • ტურისტული სააგენტო
        </small>
        <small v-else>
            {{ item.municipality.name_ka }} •
            {{ item.category.name_ka }}
        </small>
    </p>
    <div class="mt-2">
        <p class="mb-0" v-show="item.mobile">
            <i class="fas fa-phone-alt fa-sm me-1"></i>
            <small>{{ item.mobile }}</small>
        </p>
        <p class="mt-2 mb-0 text-center">
            <a
                class="btn btn-warning py-1 px-2 me-1"
                :href="`/${category}/${item.id}`"
                target="_blank"
                ><i class="fas fa-eye"></i></a
            ><a
                class="btn btn-info py-1 px-2"
                :href="`/${category}/${item.id}/edit`"
                target="_blank"
                ><i class="fas fa-pen"></i
            ></a>
        </p>
    </div>
</template>

<script>
export default {
    name: "MapItem",
    props: ["item", "category"],
};
</script>
